/**
 * Origin of rm-api for browser calls (prefix before `/api/v1`).
 *
 * Archigma serves the UI from rm-api itself, so its calls stay same-origin
 * (`''`). The Plotea web app is a static site at the apex (`plotea.com`,
 * `plotea.dev`) and calls its API at `api.<apex>` with credentials; the
 * `Domain=<apex>` auth cookies and the readable `csrf_token` make that
 * same-site. Deriving the origin from the page host keeps one Plotea web image
 * for staging and production. Any other host (local dev, e2e) stays
 * same-origin behind the Vite proxy. Contract: docs/architecture/plotea.md.
 */
export function resolveApiOrigin(
  plotea: boolean,
  location: { hostname: string } | undefined,
): string {
  if (!plotea || !location) return ''
  const apex = location.hostname.replace(/^www\./, '')
  return apex === 'plotea.com' || apex === 'plotea.dev'
    ? `https://api.${apex}`
    : ''
}
